export const capitalize = text => (typeof text === 'string' ? text.charAt(0).toUpperCase() + text.slice(1) : text)

export const intToStringLeftPad = (number, length) => {
    let str = number.toString()
    while (str.length < length) str = `0${str}`
    return str
}

export const priceFormatted = (number, numDecimals = 1) => `$${number.toFixed(numDecimals).replace(/.0+$/, '')}m`

export const minutes = m => {
    if (typeof m === 'number') return `${m.toFixed(2)}'`
    if (typeof m === 'string') return `${m}'`.replace('\'\'', '\'')
    return '-'
}



// WEBPACK FOOTER //
// src/utils/string.js